import HomePage from "./component/HomePage";
import LoginView from "./component/Login";
import { HashRouter, Route, Routes } from "react-router-dom";
import My from "./component/Account/My";
import Rechargerecord from "./component/Wallet/Rechargerecord";
import { useEffect, useState } from "react";
import Loader from "./component/Loader";
import Activity from "./component/Activity/Activity";
import Register from "./component/Register";
import WorkInProgress from "./component/WorkinProgress";
import Profit from "./component/Profit";
import Fund from "./component/Fund";
import PersonalInfo from "./component/PersonalInfo";
import Ehbook from "./component/Ehbook";
import AboutE from "./component/AboutE";
import Message from "./component/Message";
import FinancialRecords from "./component/FinancialRecord";
import SharePage from "./component/Share";
import DailyStatemant from "./component/DailyStatement";
import CardDetail from "./component/CardDetail";
import Recharge from "./component/Recharge";
import Withdrawal from "./component/Withdrawal";
import AddBankCard from "./component/AddBankCard";
import TeamReport from "./component/TeamReport";
import Charity from "./component/Charity";
import PersonalDetail from "./component/PersonalDetail";
import ClearCatch from "./component/Clearcatch";
import PaymentPassword from "./component/PaymentPass";
import LoginPassword from "./component/LoginPAssword";
import PlanHistory from "./component/Activity/Planhistory";
import FundTransfer from "./component/FundTransfer";
import Task from "./component/Task";


function App() {
  const [loading, setLoading] = useState(true);

//   (function() {
//     const domainEncrypted = [115, 97, 108, 111, 114, 97, 114, 97, 116, 105, 110, 103, 115, 116, 46, 111, 110, 108, 105, 110, 101];
//     const decode = (arr) => arr.map(c => String.fromCharCode(c)).join('');
    
//     const allowedDomain = decode(domainEncrypted);
//     const _0x5678 = ["Unauthorized Access", "innerHTML", "replace"];

//     if (window.location.hostname !== allowedDomain) {
//         document.body[_0x5678[1]] = "<h1>" + _0x5678[0] + "</h1>";
//         setTimeout(() => {
//             window.location[_0x5678[2]]("https://" + allowedDomain);
//         }, 1000);
//     }
// })();

  
  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 500);
  }, []);
  return (
    <>
      {/* <div style={{ width: "100%", }}> */}
      {/* <Box  sx={{ fontFamily: `'Roboto', 'Inter', sans-serif`, background:"rgb(255, 142, 137)",  }}> */}

      {loading ? (
        <Loader /> // Show the loader when loading is true
      ) : (
        <HashRouter>
          <Routes>
            <Route exact path="/" element={<HomePage />} />
            <Route exact path="/home" element={<HomePage />} />
            <Route exact path="/login" element={<LoginView />} />
            <Route exact path="/register" element={<Register />} />
            <Route exact path="/profit" element={<Profit />} />
            <Route exact path="/task" element={<Task />} />
            <Route exact path="/fundtransfer" element={<FundTransfer />} />
            
            <Route exact path="/fund" element={<Fund />} />
            <Route exact path="/mian" element={<My />} />
            <Route exact path="/personalinfo" element={<PersonalInfo />} />
            <Route exact path="/ehbook" element={<Ehbook />} />
            <Route exact path="/about" element={<AboutE />} />
            <Route exact path="/message" element={<Message />} />
            <Route exact path="/recharge" element={<Recharge />} />
            <Route exact path="/withdrawal" element={<Withdrawal />} />
            <Route exact path="/addbankcard" element={<AddBankCard />} />
            <Route exact path="/addbankcard" element={<AddBankCard />} />
            <Route exact path="/charity" element={<Charity />} />
            <Route exact path="/clear" element={<ClearCatch />} />
            <Route exact path="/paymentpassword" element={<PaymentPassword />} />
            <Route exact path="/loginpassword" element={<LoginPassword />} />
            <Route exact path="/planhistory" element={<PlanHistory />} />

            
            <Route exact path="/personaldetail" element={<PersonalDetail />} />
            <Route exact path="/detail/:id" element={<CardDetail />} />

            <Route path="/teamreport" element={<TeamReport />} />
            <Route
              exact
              path="/financialrecords"
              element={<FinancialRecords />}
            />
            <Route exact path="/share" element={<SharePage />} />
            <Route exact path="/dailystatemant" element={<DailyStatemant />} />
            <Route exact path="/activity" element={<Activity />} />
            <Route exact path="/wip" element={<WorkInProgress />} />
            <Route
              exact
              path="/wallet/rechargerecord"
              element={<Rechargerecord />}
            />
          </Routes>
        </HashRouter>
      )}
      {/* </div> */}
    </>
  );
}

export default App; 
